import React, { useEffect, useRef, useState } from "react";

export default function LoginView({ password, setPassword, onTryLogin, onNewAccount }) {
  const inputRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      inputRef.current?.focus();
    }, 600);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    setVH();
    window.addEventListener("resize", setVH);
    return () => window.removeEventListener("resize", setVH);
  }, []);

  const handleLogin = async () => {
    const success = await onTryLogin();
    if (!success) {
      setError("Incorrect password. Please try again.");
    } else {
      setError("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div
      style={{
        height: "calc(var(--vh, 1vh) * 100)",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#000",
        color: "#fff",
        overflow: "hidden",
        margin: 0,
        padding: 0,
      }}
    >
      <img
        src="/images/unlink_splash.png"
        alt="Unlink Logo"
        style={{
          width: "200px",
          opacity: 0,
          animation: "fadeInLogo 1s ease-in-out forwards",
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          opacity: 0,
          animation: "fadeInContent 1s ease-in-out 0.1s forwards",
        }}
      >
        <h2 style={{ marginTop: "1rem" }}>Enter Password</h2>

        <input
          ref={inputRef}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{
            padding: "0.5rem",
            fontSize: "1rem",
            marginTop: "1rem",
            marginBottom: "1rem",
            borderRadius: "4px",
            border: "none",
            width: "200px",
            backgroundColor: "rgb(50 50 50)",
            color: "#fff",
          }}
        />

        {error && (
          <div style={{ color: "#f66", marginBottom: "1rem" }}>
            {error}
          </div>
        )}

        <div style={{ display: "flex", gap: "1rem" }}>
          <button
            onClick={handleLogin}
            style={{
              padding: "0.5rem 1rem",
              fontSize: "1rem",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#4e8cff",
              color: "white",
              cursor: "pointer",
            }}
          >
            Login
          </button>

          <button
            onClick={onNewAccount}
            style={{
              padding: "0.5rem 1rem",
              fontSize: "1rem",
              borderRadius: "4px",
              border: "1px solid #4e8cff",
              backgroundColor: "transparent",
              color: "#4e8cff",
              cursor: "pointer",
            }}
          >
            New account
          </button>
        </div>
      </div>

      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          html, body {
            height: 100%;
            overflow: hidden;
            background-color: #000;
          }
          #root {
            height: 100%;
          }
          @keyframes fadeInLogo {
            to { opacity: 1; }
          }
          @keyframes fadeInContent {
            to { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}